/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconUserFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUserFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M4 4.667c-1.999 0-3 .5-3 1.666 0 .554 1.342 1 3 1 1.657 0 3-.446 3-1 0-1.167-1.001-1.666-3-1.666ZM4 4.333c.75 0 1.5-.9 1.5-2C5.5 1 4.562.667 4 .667c-.563 0-1.5.333-1.5 1.666 0 1.1.75 2 1.5 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUserFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUserFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M6 7c-2.998 0-4.5.75-4.5 2.5 0 .83 2.014 1.5 4.5 1.5s4.5-.67 4.5-1.5C10.5 7.75 8.998 7 6 7ZM6 6.5c1.125 0 2.25-1.35 2.25-3C8.25 1.5 6.844 1 6 1c-.844 0-2.25.5-2.25 2.5 0 1.65 1.125 3 2.25 3Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUserFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUserFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 9.334c-3.997 0-6 1-6 3.333 0 1.107 2.685 2 6 2s6-.893 6-2c0-2.333-2.002-3.333-6-3.333ZM8 8.667c1.5 0 3-1.8 3-4C11 2 9.125 1.334 8 1.334S5 2 5 4.667c0 2.2 1.5 4 3 4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUserFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUserFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10 11.666c-4.997 0-7.5 1.25-7.5 4.167 0 1.383 3.356 2.5 7.5 2.5s7.5-1.116 7.5-2.5c0-2.917-2.503-4.167-7.5-4.167ZM10 10.833c1.875 0 3.75-2.25 3.75-5 0-3.333-2.344-4.167-3.75-4.167-1.406 0-3.75.834-3.75 4.167 0 2.75 1.875 5 3.75 5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUserFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUserFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 14c-5.996 0-9 1.5-9 5 0 1.66 4.027 3 9 3s9-1.34 9-3c0-3.5-3.004-5-9-5ZM12 13c2.25 0 4.5-2.7 4.5-6 0-4-2.813-5-4.5-5-1.688 0-4.5 1-4.5 5 0 3.3 2.25 6 4.5 6Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconUserFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUserFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconUserFilled8 {...iconProps} />;
        case '12':
            return <IconUserFilled12 {...iconProps} />;
        case '16':
            return <IconUserFilled16 {...iconProps} />;
        case '20':
            return <IconUserFilled20 {...iconProps} />;
        case '24':
            return <IconUserFilled24 {...iconProps} />;
        default:
            return <IconUserFilled24 {...iconProps} />;
    }
});
